import { Outlet } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import RoleBasedGuard from 'components/RoleBasedGuard';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      suspense: false,
      useErrorBoundary: false
    },
  },
});

const ReviewLayout = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <RoleBasedGuard role="READ" route="Avaliação">
        <Outlet />
      </RoleBasedGuard>
    </QueryClientProvider>
  );
};

export default ReviewLayout; 